/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {
  chartCollectionAliases,
  chartCollectionIcons,
  commerceCollectionAliases,
  commerceCollectionIcons,
  coreCollectionAliases,
  coreCollectionIcons,
  essentialCollectionAliases,
  essentialCollectionIcons,
  mediaCollectionAliases,
  mediaCollectionIcons,
  socialCollectionAliases,
  socialCollectionIcons,
  technologyCollectionAliases,
  technologyCollectionIcons,
  textEditCollectionAliases,
  textEditCollectionIcons,
  travelCollectionAliases,
  travelCollectionIcons,
} from '@cds/core/icon';
import { IconAlias, IconShapeTuple } from '@cds/core/icon/interfaces/icon.interfaces';

const ICONS_TO_HIDE = ['vm-bug', 'vm-bug-inverse'];

export interface IconSet {
  setName: string;
  icons: IconShapeTuple[];
}

export const ICON_SETS = [
  {
    setName: 'Core Icons',
    icons: filterIcons(coreCollectionIcons),
  },
  {
    setName: 'Essential Icons',
    icons: filterIcons(essentialCollectionIcons),
  },
  {
    setName: 'Commerce Icons',
    icons: filterIcons(commerceCollectionIcons),
  },
  {
    setName: 'Media Icons',
    icons: filterIcons(mediaCollectionIcons),
  },
  {
    setName: 'Social Icons',
    icons: filterIcons(socialCollectionIcons),
  },
  {
    setName: 'Travel Icons',
    icons: filterIcons(travelCollectionIcons),
  },
  {
    setName: 'Text Icons',
    icons: filterIcons(textEditCollectionIcons),
  },
  {
    setName: 'Technology Icons',
    icons: filterIcons(technologyCollectionIcons),
  },
  {
    setName: 'Chart Icons',
    icons: filterIcons(chartCollectionIcons),
  },
];

export const ICON_ALIASES = {
  ...mapAliases(coreCollectionAliases),
  ...mapAliases(essentialCollectionAliases),
  ...mapAliases(commerceCollectionAliases),
  ...mapAliases(mediaCollectionAliases),
  ...mapAliases(socialCollectionAliases),
  ...mapAliases(travelCollectionAliases),
  ...mapAliases(textEditCollectionAliases),
  ...mapAliases(technologyCollectionAliases),
  ...mapAliases(chartCollectionAliases),
};

export const ICONS_STATES = {
  alerted: ['warning-triangle', 'inherit-triangle'],
  badged: ['info', 'success', 'danger', 'warning'],
};

function filterIcons(icons: IconShapeTuple[]) {
  return icons.filter(([iconName]) => !ICONS_TO_HIDE.includes(iconName));
}

function mapAliases(aliases: IconAlias[]) {
  return aliases.reduce<Record<string, string[]>>((aliasMap, [iconName, aliases]) => {
    aliasMap[iconName] = aliases;
    return aliasMap;
  }, {});
}
